import React, { Component, Fragment } from 'react';
import { Button, Grid, GridCell } from 'rmwc';
import Header from '../components/Header';
import SignIn from '../components/SignIn';
import { Text } from '../components/Text';

export class LogIn extends Component {
  componentWillMount = () => {
    const redirect = new URLSearchParams(window.location.search.slice(1)).get('redirect');

    this.setState({ redirect: redirect || '/dashboard' });
  };

  render() {
    return (
      <Fragment>
        <Header />
        <Grid>
          <GridCell span="12">
            <div className="hrbr-narrow-centered">
              <div className="m-3">
                <Text use="headline6">Returning Harbor Members</Text>
                <Text use="body1">Please sign in to your plan dashboard!</Text>
              </div>
              <SignIn onSuccess={() => (window.location = this.state.redirect)} />

              <div className="mt-4 text-center">
                <Text use="body1">Don't have an account yet?</Text>
                <Button theme="secondary-bg on-secondary" onClick={() => this.props.history.push('/start')} raised>
                  Start a New Plan
                </Button>
              </div>
            </div>
          </GridCell>
        </Grid>
      </Fragment>
    );
  }
}

export default LogIn;
